var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"25","fill":"currentColor","viewBox":"0 0 24 25"}},[_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M3 12.5h18m0 0L14.5 5m6.5 7.5L14.5 20"}})])
}
var staticRenderFns = []

export default { render: render }